export default function Logo({ className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="All Elite Research"
      className={className || "h-12 w-auto object-contain"}
    />
  );
}